import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { NotificationTemplateTypes } from '@ui/src';
import { PermissionsAction } from '../../../notification-settings/types';
import sectionActions from '../../../notification-settings/helpers/get-section-actions';

export interface EmployeeTemplateColumnState {
  sectionId: NotificationTemplateTypes;
  pageId?: NotificationTemplateTypes | 'all';
  panelIsOpen: boolean;
  popupIsOpen: boolean;
  search?: string;
  allActionsSectionFiltered?: PermissionsAction;
}

const initialState: EmployeeTemplateColumnState = {
  sectionId: NotificationTemplateTypes.SECTION_MESSAGING,
  panelIsOpen: false,
  popupIsOpen: false,
  allActionsSectionFiltered: {},
};

export const employeeTemplateColumnSlice = createSlice({
  name: 'employeeTemplateColumn',
  initialState,
  reducers: {
    handleConfirmPopup: (state, action: PayloadAction<boolean>) => {
      state.popupIsOpen = action.payload;
    },
    changePanelState: (state, action: PayloadAction<boolean>) => {
      state.panelIsOpen = action.payload;
    },
    onSearch: (state, action: PayloadAction<string>) => {
      state.search = action.payload;
    },
    onSectionChange: (
      state,
      action: PayloadAction<NotificationTemplateTypes>,
    ) => {
      state.sectionId = action.payload;
      state.allActionsSectionFiltered = action.payload
        ? sectionActions[action.payload]
        : {};
      state.search = '';
    },
    onPageChange: (
      state,
      action: PayloadAction<NotificationTemplateTypes | undefined>,
    ) => {
      state.pageId = action.payload;
    },
  },
});

export const {
  changePanelState,
  onSectionChange,
  onPageChange,
  handleConfirmPopup,
  onSearch,
} = employeeTemplateColumnSlice.actions;

export default employeeTemplateColumnSlice.reducer;
